import * as React from 'react';
import { BreadcrumbStore } from '../data/stores/BreadcrumbStore';
import { CalculationStore } from '../data/stores/CalculationStore';
import { EntitiesStore } from '../data/stores/EntitiesStore';
import { GroupStore } from '../data/stores/GroupStore';
import { LoansStore } from '../data/stores/LoansStore';
import { NavigationStore } from '../data/stores/NavigationStore';
import { NoticeStore, NoticeStoreInstance } from '../data/stores/NoticeStore';
import { UserStore } from '../data/stores/UserStore';
import { NotificationStore } from '../data/stores/NotificationStore';
import { ExchangeRatesStore } from '../data/stores/ExchangeRatesStore';
import { AccountMappingsStore } from '../data/stores/AccountMappingsStore';
import { LoanAccountsStore } from '../data/stores/LoanAccountsStore';
import { ApportionmentsStore } from '../data/stores/ApportionmentsStore';

export type AppContextType = {
  AccountMappingsStore: AccountMappingsStore,
  ApportionmentsStore: ApportionmentsStore,
  BreadcrumbStore: BreadcrumbStore,
  CalculationStore: CalculationStore,
  EntitiesStore: EntitiesStore,
  ExchangeRatesStore: ExchangeRatesStore,
  GroupStore: GroupStore,
  LoansStore: LoansStore,
  NoticeStore: NoticeStore
  NavigationStore: NavigationStore,
  UserStore: UserStore,
  NotificationStore: NotificationStore,
  LoanAccountsStore: LoanAccountsStore,
};

const entitiesStore = new EntitiesStore();
const groupStore = new GroupStore();

export const AppContext = React.createContext({
  AccountMappingsStore: new AccountMappingsStore(),
  ApportionmentsStore: new ApportionmentsStore(),
  BreadcrumbStore: new BreadcrumbStore(),
  CalculationStore: new CalculationStore(entitiesStore),
  EntitiesStore: entitiesStore,
  ExchangeRatesStore: new ExchangeRatesStore(),
  GroupStore: groupStore,
  LoansStore: new LoansStore(),
  NoticeStore: NoticeStoreInstance,
  NavigationStore: new NavigationStore(groupStore),
  UserStore: new UserStore(),
  NotificationStore: new NotificationStore(),
  LoanAccountsStore: new LoanAccountsStore(),
});
